import Variant1 from './Variant1';
import Variant2 from './Variant2';

export default {
  Variant1,
  Variant2
};
